<h2 mat-dialog-title>{{ isNew ? 'Tambah' : 'Ubah' }} Pengguna</h2>
<mat-dialog-content class="mat-typography">
    <form class="form-container" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>NIP</mat-label>
                <input matInput [formControl]="email" required />
                <mat-error *ngIf="email.invalid">{{
                    getEmailErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Nama Lengkap</mat-label>
                <input matInput placeholder="Ir. Soekarno" [formControl]="name" required />
                <mat-error *ngIf="name.invalid">{{ getNameErrorMessage() }}</mat-error>
            </mat-form-field>
        </p>
        <p *ngIf="isNew">
            <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="password" />
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <mat-icon>{{
                        hidePassword ? 'visibility_off' : 'visibility'
                        }}</mat-icon>
                </button>
                <mat-error *ngIf="password.invalid">{{
                    getPasswordErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p *ngIf="isNew">
            <mat-form-field appearance="outline">
                <mat-label>Ketik Ulang Password</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="retypePassword" />
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <mat-icon>{{
                        hidePassword ? 'visibility_off' : 'visibility'
                        }}</mat-icon>
                </button>
                <mat-error *ngIf="retypePassword.invalid">{{
                    getRetypePasswordErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-select [formControl]="substansi" ngDefaultControl>
                    <mat-option *ngFor="let item of substansis" [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Atasan Langsung</mat-label>
                <input type="text" matInput [formControl]="atasan" [matAutocomplete]="autoAtasan" required />
                <mat-autocomplete #autoAtasan="matAutocomplete" [displayWith]="displayOpt">
                    <mat-option *ngFor="let item of filteredAtasans" [value]="item">
                        {{ item.fullname }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="atasan.invalid">{{
                    getErrorMessage(atasan)
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Pejabat Berwenang Memberikan Cuti</mat-label>
                <input type="text" matInput [formControl]="pejabat" [matAutocomplete]="autoPejabat" required />
                <mat-autocomplete #autoPejabat="matAutocomplete" [displayWith]="displayOpt">
                    <mat-option *ngFor="let item of filteredPejabats" [value]="item">
                        {{ item.fullname }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="pejabat.invalid">{{
                    getErrorMessage(pejabat)
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p *ngIf="isSuperAdmin()"><strong>Sebagai*</strong></p>
        <form [formGroup]="formRole" *ngIf="isSuperAdmin()">
            <mat-grid-list cols="3" rowHeight="36px">
                <mat-grid-tile *ngFor="let role of rolesFormArray.controls; let i = index">
                    <div class="arch-grid-tile">
                        <label formArrayName="roles">
                            <mat-checkbox [formControlName]="i">
                                {{ roles[i].name }}
                            </mat-checkbox>
                        </label>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
        </form>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close *ngIf="!isLoading">Batal</button>
    <button mat-raised-button cdkFocusInitial color="primary" *ngIf="!isLoading" (click)="f.form.valid && onSubmit()">
        Simpan
    </button>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</mat-dialog-actions>